/**
 * ProblemStatement component is used to display the Activity title and the problem statement of a programming
 * activity within a course.
 */

import React, { useState } from "react";
import { Accordion, Card } from "react-bootstrap";
import { RiArrowDropDownLine, RiArrowDropRightLine } from "react-icons/ri";

export default function ProblemStatement({ activity_title, activity_description, document }) {
  //State to manage the accordion open and close
  const [isAccordionOpen, setIsAccordionOpen] = useState(true);

  const renderDocumentAlert = () => {
    if (!document) {
      return null;
    }
    //Rendering an alert to inform the student about the additional files provided by the instructor
    return (
      <>
        <h5 style={{ marginBottom: "10px" }}>
          Helper Document:{"  "}
          <a
            href={URL.createObjectURL(document)}
            download={document.name}
            style={{ marginRight: "8px" }}
          >
            <u>{document.name}</u>
            {""}
          </a>
        </h5>
      </>
    );
  };

  return (
    <div>
      {/* Activity title */}
      <div style={{ marginLeft: "10px", marginBottom: "25px" }}>
        <h2>{activity_title}</h2>
      </div>
      {/* Accordion to display the problem statement */}
      <Accordion defaultActiveKey="0">
        <Card>
          <Accordion.Toggle
            as={Card.Header}
            onClick={() => setIsAccordionOpen(!isAccordionOpen)}
          >
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div>Problem Statement</div>
              <div>
                {isAccordionOpen ? (
                  <RiArrowDropDownLine
                    size={35}
                    color="grey"
                    style={{ margin: "-10 0 -10 10" }}
                  />
                ) : (
                  <RiArrowDropRightLine
                    size={35}
                    color="grey"
                    style={{ margin: "-10 0 -10 10" }}
                  />
                )}
              </div>
            </div>
          </Accordion.Toggle>
          <Accordion.Collapse in={isAccordionOpen}>
            <Card.Body>
              <>
                  {renderDocumentAlert()}
                <div
                  style={{
                    maxHeight: "550px",
                    overflow: "auto",
                    wordWrap: "break-word",
                  }}
                  // Display the problem statement using dangerouslySetInnerHTML to render the HTML content
                  dangerouslySetInnerHTML={{ __html: activity_description }}
                />
              </>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    </div>
  );
}
